/* eslint-disable react-hooks/exhaustive-deps */
import { useApolloClient } from "@apollo/client";
import Button from "@mostrans/web-components/components/base/Button";
import Input from "@mostrans/web-components/components/base/Input";
import {
  Box,
  Checkbox,
  Chip,
  Dialog,
  Divider,
  FormControlLabel,
  FormGroup,
  IconButton,
  Typography,
} from "@mui/material";
import FG from "@mostrans/web-components/components/base/FormGroup";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import { createSkill, updateSkillProfileCandidate } from "../../../../graphql/mutations";
import { getCandidateByID, getMasterSkill } from "../../../../graphql/query";
import { getDetailCandidate } from "../../../../shared/atom/detailCandidate";
import { getMasterSkillAtom } from "../../../../shared/atom/getDataMaster";
import { globalLoadingAtom } from "../../../../shared/globalStates";
import { capitalizeEachWord, toastError, toastSuccess } from "../../../../shared/helpers";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

export default function Skills({ open, setOpen, handleClose, setData, data }) {
  const client = useApolloClient();
  const [masterSkill, fetchMasterSkill] = useRecoilState(getMasterSkillAtom);
  const [skills, setSkills] = useState([]);
  const [customSkill, setCustomSkill] = useState([]);
  const [error, setError] = useState(false);
  const [candidate, setDetailCandidate] = useRecoilState(getDetailCandidate);
  const setLoading = useSetRecoilState(globalLoadingAtom);
  const [selected, setSelected] = useState([]);
  useEffect(() => {
    setLoading(true);
    if (isEmpty(masterSkill)) {
      getMasterSkill(client)
        .then((result) => {
          const skills = result.map((o) => o.skill);
          const filtered = result.filter(({ skill }, index) => !skills.includes(skill, index + 1));
          fetchMasterSkill(filtered);
          setSkills(filtered);
        })
        .catch(() => {
          console.log("Error->Skills");
        });
    }
    if (isEmpty(candidate)) {
      getCandidateByID(client)
        .then((result) => {
          if (result.skills && result.skills.length > 0) {
            result.skills.map((item, i) =>
              setSelected((old) => {
                old[i] = item;
                return [...old];
              })
            );
          }
          setDetailCandidate(result);
        })
        .catch(() => {
          console.log("Error->Skills");
        });
    } else {
      if (candidate.skills && candidate.skills.length > 0) {
        candidate.skills.map((item, i) =>
          setSelected((old) => {
            old[i] = item;
            return [...old];
          })
        );
      }
    }
    handleButton();
    setSkills(masterSkill);
    setLoading(false);
  }, []);

  const handleSearch = (e) => {
    let search = e.target.value;
    if (!isEmpty(search)) {
      const skills = masterSkill.map((o) => o.skill);
      const filtered = masterSkill.filter(({ skill }, index) => !skills.includes(skill, index + 1));
      const filter = filtered.filter((item) => {
        return item.skill.toLowerCase().indexOf(search) !== -1;
      });
      setSkills(filter);
    } else {
      setSkills(masterSkill);
    }
  };

  const handleSave = async () => {
    if (selected.length > 20) {
      toastError("Skills can't be more than 20!");
      return;
    }
    setLoading(true);
    const values = selected.filter((n) => n);
    const response = await updateSkillProfileCandidate(client, values);
    setLoading(false);
    if (response.status !== "000") {
      toastError("Error, try again later!");
    } else {
      setSkills(masterSkill);
      fetchMasterSkill(masterSkill);
      toastSuccess("Success");
      setOpen(false);
      setData({
        skills: values,
      });
    }
  };

  const handleDelete = (item) => {
    setSelected((old) => {
      if (old.includes(item)) {
        const index = old.indexOf(item);
        if (index > -1) {
          old.splice(index, 1);
        }
      } else {
        return [...old, item];
      }
      return [...old];
    });
  };

  const handleButton = () => {
    if (selected?.toString() === data.skills?.toString()) {
      return true;
    } else {
      return false;
    }
  };

  const handleCustomAdd = async () => {
    const skill = await createSkill(client, customSkill);
    if (skill.status !== "000") {
      toastError("Error, try again later");
    } else {
      getMasterSkill(client).then((result) => {
        const skills = result.map((o) => o.skill);
        const filtered = result.filter(({ skill }, index) => !skills.includes(skill, index + 1));
        setSkills(filtered);
        fetchMasterSkill(filtered);
      });
    }
    setSelected((old) => {
      if (old.includes(customSkill)) {
        setCustomSkill("");

        return [...old];
      } else {
        setCustomSkill("");

        return [...old, customSkill];
      }
    });
  };
  return (
    <React.Fragment>
      <Button
        variant="text"
        color="primary"
        size="small"
        type="tertiary"
        onClick={() => {
          setOpen(true);
        }}
        startIcon={<span className="material-icons"> edit </span>}
        sx={{ fontSize: "14px" }}>
        Edit Skills
      </Button>
      <Dialog maxWidth="xs" open={open} onClose={handleClose}>
        <Box fontSize={16}>
          <Box p={2}>
            <Typography variant="h4">HARD SKILL & SOFT SKILL</Typography>
          </Box>
          <Divider />
          <Box p={2}>
            <Typography>
              Choose your strongest skill. This will allow HR to better understand your suitability
              for the job.
            </Typography>
            <Input
              placeholder="Search skill"
              onChange={(e) => handleSearch(e)}
              style={{ width: "100%", margin: "10px 0" }}
            />
            <Box overflow="scroll" pl={8} height="130px">
              <Box sx={{ display: "flex", flexFlow: "row wrap" }}>
                {skills || skills.length > 0
                  ? skills.map(
                      (item, i) =>
                        i < 50 && (
                          <FormGroup key={item.id} style={{ flexBasis: "50%" }}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={selected.includes(item.skill)}
                                  onChange={() =>
                                    setSelected((old) => {
                                      if (old.includes(item.skill)) {
                                        const index = old.indexOf(item.skill);
                                        if (index > -1) {
                                          old.splice(index, 1); // 2nd parameter means remove one item only
                                        }
                                      } else {
                                        return [...old, item.skill];
                                      }
                                      return [...old];
                                    })
                                  }
                                  sx={{ mr: "10px" }}
                                />
                              }
                              sx={{
                                textTransform: "capitalize",
                              }}
                              label={item.skill}
                            />
                          </FormGroup>
                        )
                    )
                  : null}
              </Box>
            </Box>
            <Typography py={1} fontWeight={400}>
              {selected.filter((item) => item !== null && item !== undefined).length} Skill selected
            </Typography>
            {!isEmpty(selected) &&
              selected.map((item, i) => (
                <Chip
                  key={i}
                  label={item}
                  size="small"
                  onDelete={() => handleDelete(item)}
                  deleteIcon={<DeleteIcon />}
                  sx={{
                    fontSize: "16px",
                    textTransform: "capitalize",
                    margin: "5px",
                  }}
                />
              ))}
            <div className="input__skills" style={{ display: "flex" }}>
              <FG
                className="font-size-small"
                showChildErrorSign
                isError={error}
                errorMessage={"Value too long"}
                style={{ margin: "5px" }}>
                <Input
                  placeholder="Add skill"
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      if (customSkill.length > 20) {
                        setError(true);
                        return;
                      } else {
                        setError(false);
                        handleCustomAdd();
                      }
                    }
                  }}
                  value={customSkill}
                  onChange={(e) => {
                    if (customSkill.length < 20) setError(false);
                    setCustomSkill(capitalizeEachWord(e.target.value));
                  }}
                  size="small"
                  style={{
                    width: "150px",
                    borderRadius: "16px",
                  }}
                />
              </FG>
              <IconButton
                disabled={!customSkill.length}
                onClick={() => {
                  if (customSkill.length > 20) {
                    setError(true);
                    return;
                  } else {
                    setError(false);
                    handleCustomAdd();
                  }
                }}>
                <AddIcon />
              </IconButton>
            </div>
          </Box>

          <Divider />
          <Box p={2} textAlign="end">
            <Button
              onClick={() => {
                setOpen(false);
                if (candidate.skills && candidate.skills.length > 0) {
                  candidate.skills.map((item, i) =>
                    setSelected((old) => {
                      old[i] = item;
                      return [...old];
                    })
                  );
                }
                setSkills(masterSkill);
                fetchMasterSkill(masterSkill);
              }}
              variant="outlined"
              color="danger">
              Cancel
            </Button>
            <Button disabled={handleButton()} onClick={() => handleSave()}>
              Save
            </Button>
          </Box>
        </Box>
      </Dialog>
    </React.Fragment>
  );
}
